import { Controller } from "@hotwired/stimulus"

// Formulario de recursos: al elegir una unidad carga en un frame la lista de
// sus clases (para ubicar la nueva) y sugiere el número siguiente cuando el
// campo "número de clase" está vacío.
export default class extends Controller {
  static targets = ["frame", "posicion"]
  static values = { url: String }

  // El change del combobox burbujea desde su input hidden; se filtra por
  // nombre para no reaccionar al propio campo numérico.
  cargar(event) {
    if (event.target.name !== "resource[unit_id]") return

    const id = event.target.value
    if (id) {
      this.frameTarget.src = this.urlValue.replace("ID", id)
    } else {
      this.frameTarget.removeAttribute("src")
      this.frameTarget.innerHTML = ""
      if (this.hasPosicionTarget) this.posicionTarget.value = ""
    }
  }

  sugerir() {
    const sugerido = this.frameTarget.querySelector("[data-sugerido]")?.dataset.sugerido
    if (sugerido && this.hasPosicionTarget && !this.posicionTarget.value) {
      this.posicionTarget.value = sugerido
      // Asignar .value no emite eventos; el autoguardado debe enterarse.
      this.posicionTarget.dispatchEvent(new Event("input", { bubbles: true }))
    }
  }
}
